module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.8fd9b544.jpg";